import React, { memo, useCallback, useEffect, useState } from 'react';
import { Company } from '@app/models';
import { getCompanyByBin } from '@app/api';
import { ProfileCompany, WelcomeBanner } from '@app/common';
import { Loader, Container } from '@app/components';
import { LayoutDefault } from '@app/layouts';
import { Card } from 'components/ui/card';
import { useParams } from 'react-router-dom';

function PageCompany() {
  const { bin } = useParams<'bin'>();
  const [error, setError] = useState<boolean>(false);
  const [pending, setPending] = useState<boolean>(true);
  const [company, setCompany] = useState<Company | null>(null);

  const getData = useCallback(async () => {
    try {
      if (!bin) return;

      const response = await getCompanyByBin(bin as string);

      setCompany(response);
      setError(false);
      setPending(false);
    } catch (e) {
      setPending(false);
      setError(true);
    }
  }, [bin]);

  useEffect(() => {
    getData();
  }, []);

  if (pending) {
    return (
      <Card className="flex justify-center items-center p-8">
        <Loader />
      </Card>
    );
  }

  return (
    <LayoutDefault>
      <WelcomeBanner />
      {pending && (
        <Card className="flex justify-center items-center p-8">
          <Loader />
        </Card>
      )}
      <Container className="grid gap-4">
        {company && <ProfileCompany company={company} editable={false} />}
      </Container>
    </LayoutDefault>
  );
}

export default memo(PageCompany);
